import { render } from "./ContactHeader.vue?vue&type=template&id=49c035c8&scoped=true"
import script from "./ContactHeader.vue?vue&type=script&lang=js"
export * from "./ContactHeader.vue?vue&type=script&lang=js"

import "./ContactHeader.vue?vue&type=style&index=0&id=49c035c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c035c8"]])

export default __exports__